import Chart from './components/Chart';
import ChartPie from './components/ChartPie';

export default {
    Chart,
    ChartPie
};